import React, {useState, useEffect} from 'react';
import {SdfWizardLayout, SdfWizardStepsVertical, SdfWizardStepsVerticalItem, SdfButton, SdfIcon, SdfFocusPane, SdfBusyIndicator} from '@synerg/react-components';
import StepOne from './steps/stepOne';
import {useForm} from 'react-hook-form';
import StepTwo from './steps/stepTwo';
import StepThree from './steps/stepThree';
import StepFour from './steps/stepFour';
import axios from 'axios';
import {parsePhoneNumber} from 'libphonenumber-js';
import trim from 'lodash/trim';
import {uniqueId, get} from 'lodash';


const defaultValuesStepTwo = {
		partnerOrganization: '',
		clientId: '',
		businessAddress: '',
		businessAddressOptional: '',
		domainOptional: '',
		city: '',
		state: {},
		postalCode: '',
}

const defaultValuesStepThree = {
		firstName: '',
		lastName: '',
		preferredPhoneNumber: {},
		emailAddress: '',
}

const defaultValuesStepFour = {
		partnerDevelopmentAdvisor: '',
		businessDevelopmentAdvisor: '',
		technicalAdvisor: '',
}


export default function AddNewPartnerModal({ setShowAddPartner, setAddedNewPartner, setToast}){

		const {
			control: control1,
			formState: formState1,
			getValues: getVal1,
		} = useForm({ mode: "onChange", defaultValuesStepTwo });

		const {
			control: control2 ,
			formState: formState2,
			getValues: getVal2,
		} = useForm({ mode: "onChange", defaultValuesStepThree });

		const {
			control: control3,
			formState: formState3,
			getValues: getVal3,
		} = useForm({ mode: "onChange", defaultValuesStepFour });


		const [activeStep, setActiveStep] = useState(0);
		const [validForm1, setValidForm1] = useState(true);
		const [validForm2, setValidForm2] = useState(true);
		const [, setValidForm3] = useState(true);
		const [selectedRadioBtnIndex, setSelectedRadioBtnIndex] = useState(null);
		const [ advisors, setAdvisors ] = useState({ technical: [], business: [], partner: [] });
		const [ advisorsError, setAdvisorError] = useState(false);
		const [ retry, setRetry ] = useState(0);
		const [loading, setLoading] = useState(false);

		const handleResponse = (message, status = "error") => {
			setToast({
				key: uniqueId(),
				status: status,
				message: message,
				showToast: true
			});
		};

		const backClickHandler = () => {
			if (activeStep !== 0) {
				setActiveStep(activeStep - 1);
			}
		};

		const nextClickHandler = async () => {
				if(activeStep < 3){
					setActiveStep(activeStep + 1);
				}else{
					await addPartner();
				}
		};

		const addPartner = async() => {
			try{
				setLoading(true);
				const addressFields = [getVal1().businessAddress, getVal1().city, get(getVal1(), 'state.value', ''), getVal1().postalCode];
				const includeAddress = addressFields.every(Boolean);
				if(addressFields.some(Boolean) && !includeAddress){
						setActiveStep(1);
						setLoading(false);
						return handleResponse('Fill in remaining address fields!', 'error');
				}

				const preferredPhoneNumber = parsePhoneNumber(getVal2().preferredPhoneNumber.valueInternational).formatInternational();
				const dialNumber = trim(getVal2().preferredPhoneNumber.valueNational, '-() ');
				const emailAddress = trim(getVal2().emailAddress);
				const partnerType = selectedRadioBtnIndex === 0 ? 'marketplace' : selectedRadioBtnIndex === 1 ? 'datacloud' : 'b2c';

				const dataToSend = {
					...getVal1(),
					...getVal2(),
					includeAddress,
					preferredPhoneNumber,
					countryDialing: `+${getVal2().preferredPhoneNumber.countryCode}`,
					dialNumber,
					emailAddress,
					partnerType,
					partnerDevelopmentAdvisor: get(getVal3(), 'partnerDevelopmentAdvisor.value', ''),
					businessDevelopmentAdvisor: get(getVal3(), 'businessDevelopmentAdvisor.value', ''),
					technicalAdvisor: get(getVal3(), 'technicalAdvisor.value', ''),
					state: get(getVal1(), 'state.value', '')
				}

				const { status, data } = await axios.post(`${import.meta.env.VITE_ROOT_PATH}/api/partner`, dataToSend);

				if(status === 200){
					setLoading(false);
					handleResponse(`${dataToSend.partnerOrganization} added successfully!`, 'success');
					//close Modal
					setAddedNewPartner(dataToSend.clientId);
					setShowAddPartner(false);
				}else{
					setAddedNewPartner(false);
					setLoading(false);
					handleResponse(get(data, 'response.data.cause', 'Error when trying to create new partner'), 'error');
				}

			}catch(e){
				setAddedNewPartner(false);
				setLoading(false);
				handleResponse(get(e, 'response.data.cause', 'Error when trying to create new partner'), 'error');
			}
		}


		function canGoNext() {
			switch (activeStep) {
				case 0:
					if (selectedRadioBtnIndex === 0 || selectedRadioBtnIndex === 1 || selectedRadioBtnIndex === 2) {
						return true;
					}
					break;
				case 1:
					return validForm1
				case 2:
					return validForm2
				case 3:
					return true;
				default:
					return false;
			}
		}

	useEffect( () => {

		if (formState1.isValid) {
			setValidForm1(true);
		}else {
			setValidForm1(false);
		}

		if (formState2.isValid) {
			setValidForm2(true);
		} else {
			setValidForm2(false)
		}

		if (formState3.isValid) {
			setValidForm3(true);
		} else {
			setValidForm3(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[formState1.isValid, formState2.isValid, formState3.isValid] )


		const getAdvisors = async () => {
			try {
				const { data: { technical, business, partner } } = await axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/advisors`);
				setAdvisors( {technical, business, partner} );
				setAdvisorError(false);
			} catch (error) {
				setAdvisorError(true);
			}
		};

		useEffect(() => {
			getAdvisors();
		}, [retry]);

	return(
	<div>
		<SdfFocusPane dismissLabel='Cancel' acceptLabel='Next' spacing='xl'  size='xl' visible={true} hideFooter={true} closeable={true} onSdfDismiss={() => {setAddedNewPartner(false); setShowAddPartner(false);}}>
			<div className='px-6' style={{height: '722px'}}>
          <span slot="title" className="text-heading-06 font-black">
            Add new partner
          </span>

				<SdfWizardLayout>
					<div slot='page-content' className='px-8 min-w-fit'>
						{activeStep === 0 && <StepOne control={control1} selectedRadioBtnIndex={selectedRadioBtnIndex}
													  setSelectedRadioBtnIndex={setSelectedRadioBtnIndex}/> }
						{activeStep === 1 && <StepTwo control={control1}/> }
						{activeStep === 2 && <StepThree control={control2}/> }
						{activeStep === 3 && <StepFour control={control3} advisors={advisors} error={advisorsError} setRetry={setRetry}/> }
					</div>

					<SdfWizardStepsVertical slot='wizard-steps' className='flex-grow-0 w-64' style={{marginTop: '30px'}}>
						<SdfWizardStepsVerticalItem className='w-48' stepStatus='visited' isCurrent={activeStep === 0}>Partner type</SdfWizardStepsVerticalItem>
						<SdfWizardStepsVerticalItem className='w-64' isCurrent={activeStep === 1} stepStatus={activeStep > 1 ? 'visited' : 'unvisited'}>Partner organization details</SdfWizardStepsVerticalItem>
					  <SdfWizardStepsVerticalItem className='w-64' stepStatus={activeStep > 2 ? 'visited' : 'unvisited'} isCurrent={activeStep === 2}>Assign an admin</SdfWizardStepsVerticalItem>
						<SdfWizardStepsVerticalItem className='w-64' stepStatus={activeStep > 3 ? 'visited' : 'unvisited'} isCurrent={activeStep === 3}>Add ADP advisors</SdfWizardStepsVerticalItem>
					</SdfWizardStepsVertical>

					<SdfButton slot='buttons' variant='contained' onClick={() => {setShowAddPartner(false)}}> Cancel </SdfButton>
					{ activeStep > 0 && <SdfButton slot='buttons' variant='contained' onClick={backClickHandler}><SdfIcon icon="nav-move-left" slot=""></SdfIcon> Back</SdfButton>}
					<SdfButton disabled={!canGoNext() ? 'true' : undefined} slot='buttons' emphasis='primary' iconPlacement='after'  variant='contained' onClick={nextClickHandler}>{ activeStep === 3 ? 'Create partner' : 'Next' }{ activeStep !== 3 && <SdfIcon icon='nav-move-right' slot=""></SdfIcon>}</SdfButton>

				</SdfWizardLayout>
			</div>
			{loading && <SdfBusyIndicator overlay={true} size='lg' fullScreen={true}/>}
		</SdfFocusPane>
	</div>
	)

}
